import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { MultiSelect } from 'primereact/multiselect';

import { displayActionCardHeader } from 'modules/automation/utils/displayActionCardHeader';
import { AttachmentInput, FormLabel, TrackTime } from 'modules/automation/WorkflowBuilder/components';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import { automationModules, generalContactListOptions, generalLeadContactListLead } from 'constants/automation';
import TextSnippetWrapper from 'components/TextSnippetWrapper';

const TextMessage = ({ index }) => {
  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext();
  const trigger = watch('trigger');
  const is_for_lead = watch('is_lead_automation');
  const isForLeadAutomation = (trigger?.module === automationModules.LEADS || is_for_lead) && trigger?.code !== 'TRIG_LEAD_CONV_CASE';

  return (
    trigger?.code !== 'TRIG_REVIEW_REQUEST' && (
      <>
        {displayActionCardHeader('Text Message Configuration')}

        <div className="d-flex py-2 flex-column">
          <FormLabel label="Contacts" isRequired />

          <Controller
            name={`actions[${index}].contact_assignees`}
            control={control}
            rules={{ required: 'Please select at least one contact' }}
            render={({ field: { name, value, onChange } }) => (
              <MultiSelect
                name={name}
                value={value}
                options={isForLeadAutomation ? generalLeadContactListLead : generalContactListOptions}
                onChange={(e) => onChange(e.value)}
                placeholder="Select Contacts"
                className="w-50 p-dropdown"
                filter
                display="chip"
              />
            )}
          />
          <RequiredValidation errors={errors} field={`actions.${index}.contact_assignees`} />

          {isForLeadAutomation && (
            <div className="d-flex mt-2 files-note">
              <i className="pi pi-info-circle me-1"></i>
              If 'On Behalf Of' contact is not available, 'Client' will be used automatically, even if not selected.
            </div>
          )}
        </div>

        <div className="d-flex py-2 flex-column">
          <FormLabel label="Message" isRequired />

          <Controller
            name={`actions[${index}].message_body`}
            control={control}
            rules={{ required: 'Message is required' }}
            render={({ field: { name, value, onChange } }) => (
              <TextSnippetWrapper
                type="textarea"
                value={value}
                name={name}
                rows={5}
                cols={30}
                autoResize
                className="border shadow-small w-100"
                placeholder="Send a Message..."
                onChange={(e) => {
                  e?.target?.value?.trimStart();
                  onChange(e);
                }}
                autoComplete="off"
              />
            )}
          />
          <RequiredValidation errors={errors} field={`actions.${index}.message_body`} />
        </div>

        {/* ATTACHMENTS */}
        <div className="col-12">
          <FormLabel label="Attachments" />
          <AttachmentInput index={index} multiple={false} />
        </div>
        <TrackTime index={index} />
      </>
    )
  );
};

export default TextMessage;
